import { useAuthContext } from '@inbox-demo-nx/contexts';
import { isChannelVerified } from '@inbox-demo-nx/utils-chat-common';
import { useMemo } from 'react';
import SendBird from 'sendbird';

import { BadgeProps, VerifiedBadge } from './Badge';
import UserBadge from './UserBadge';

export default function ChannelBadge({
  channel,
  ...props
}: { channel: SendBird.GroupChannel } & Omit<BadgeProps, 'source'>) {
  const { currentUser } = useAuthContext();

  const otherUser = useMemo(() => {
    if (channel.members.length !== 2 || !currentUser) {
      return null;
    }
    return channel.members.find(
      (member) => member.userId !== currentUser.userId
    );
  }, [channel.members, currentUser]);

  if (isChannelVerified(channel)) {
    return <VerifiedBadge {...props} />;
  }

  return otherUser ? <UserBadge user={otherUser} {...props} /> : null;
}
